<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 40 40" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="M18.5 21.2C8.2 21.2.1 26.3.1 32.9v2.4c0 2.2 1.6 4.1 3.8 4.4h28.5c.2 0 .5 0 .7-.1.4-.1.7-.2 1.1-.3v.4-.4c1.6-.7 2.7-2.3 2.7-4.1v-2.4c0-6.5-8.1-11.6-18.4-11.6zm15.4 14.1c0 .7-.5 1.3-1.2 1.5H4.2c-.7-.1-1.2-.7-1.2-1.5v-2.4c0-4.7 7.1-8.7 15.4-8.7 8.4 0 15.4 4 15.4 8.7v2.4zm-15-15c5.5 0 10-4.5 10-10V.3h-10c-5.5 0-10 4.5-10 10s4.5 10 10 10zm0-17h7v7c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7zm11.6 15.4h8c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5h-8c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5zm8 2.4h-4c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h4c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5z" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
